import { useEffect, useState, useCallback } from 'react';
import mixpanel from 'mixpanel-browser';
import { useLocation } from 'react-router-dom';
import { MIX_PANEL_TOKEN, MODE } from '../../constants/config';
import { ROUTES } from '../../routes';
import { initMixpanel } from '../../store/global/global.slice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

const routes = [
  {
    path: ROUTES.INVITE,
  },
];

export const MixPanel = (): null => {
  const { pathname } = useLocation();

  const [applicationName, setApplicationName] = useState('');

  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.auth.user);
  const isMixpanelInitialized = useAppSelector(
    (state) => state.global.isMixpanelInitialized
  );

  const getPageLocationName = useCallback(() => {
    const currentRoute = routes.find(({ path }) => path === pathname);

    let currentLocation = '';

    if (currentRoute) {
      const { path } = currentRoute;

      switch (path) {
        case ROUTES.INVITE:
          currentLocation = `${applicationName}.signup`;
          break;
        default:
          break;
      }
    } else if (pathname.includes('/login')) {
      currentLocation = `${applicationName}.login`;
    }

    return currentLocation;
  }, [applicationName, pathname]);

  useEffect(() => {
    if (MODE !== 'local') {
      mixpanel.init(MIX_PANEL_TOKEN, {
        record_sessions_percent: 100,
        record_mask_text_selector: '',
        debug: MODE !== 'prod',
      });
      setApplicationName('signup');
      dispatch(initMixpanel());
    }
  }, [dispatch]);

  useEffect(() => {
    if (user && isMixpanelInitialized) {
      mixpanel.identify(`${user.orgId}|${user.userId}`);

      mixpanel.people.set({
        name: user.name,
        firstName: user.firstName,
        lastName: user.lastName,
        orgId: user.orgId,
        userId: user.userId,
      });
    }
  }, [isMixpanelInitialized, user]);

  useEffect(() => {
    if (MODE !== 'local' && applicationName) {
      mixpanel.track(getPageLocationName());
    }
  }, [applicationName, getPageLocationName]);

  return null;
};
